import UploadRequestedDocument from './UploadRequestedDocument.component';

export default UploadRequestedDocument;